exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReactModal__Overlay {\r\n    z-index: 2000 !important;\r\n}", ""]);

// exports
